import { render } from "./ListPlaylistVideoView.vue?vue&type=template&id=517a828b"
import script from "./ListPlaylistVideoView.vue?vue&type=script&lang=js"
export * from "./ListPlaylistVideoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__